import { observer } from 'mobx-react-lite'
import classNames from 'classnames'

import { Link } from '@authy/lib-web/components'

import { adminAppState } from '@/appState'

import { itemHoverActiveClasName, itemInactiveClassName } from './utils'
import { Divider } from './Divider'

type MenuProps = {
    collapsed: boolean
    onActivate: () => void
}

export const Menu = observer(({ collapsed, onActivate }: MenuProps) => {
    const { mainNavigation } = adminAppState

    return (
        <>
            <div
                className={classNames('shrink-0 grow-0', {
                    'px-3': !collapsed,
                    'pl-1 pr-2': collapsed,
                })}
            >
                <div className={classNames('flex flex-col', { 'gap-y-0.5': !collapsed })}>
                    {mainNavigation!.map(({ header, item }) => {
                        if (header) {
                            return (
                                <div
                                    key={header}
                                    className={classNames('text-light px-2 text-xs font-medium', {
                                        'pb-1 pt-2.5': !collapsed,
                                        'bg-divide my-2 h-px': collapsed,
                                    })}
                                >
                                    {!collapsed && header}
                                </div>
                            )
                        } else if (item) {
                            const { name, Icon, activeOptions, className, ...linkProperties } = item

                            return (
                                // @ts-expect-error this is due to the activeOptions we force here
                                <Link
                                    key={linkProperties?.to || name}
                                    {...linkProperties}
                                    activeOptions={{
                                        exact: false,
                                        includeSearch: false,
                                        includeHash: false,
                                        ...(activeOptions || {}),
                                    }}
                                    className={classNames(
                                        className,
                                        itemHoverActiveClasName,
                                        'relative flex shrink-0 grow-0 items-center gap-x-2 rounded-md px-2 py-2',
                                        {
                                            'justify-center': collapsed,
                                        }
                                    )}
                                    inactiveClassName={itemInactiveClassName}
                                    activeClassName={classNames(
                                        'font-medium text-primary before:hidden md:before:block before:border-r-4 before:border-r-neutral-950 dark:before:border-r-neutral-50 before:top-1.5 before:bottom-1.5 before:absolute before:-ml-2 before:rounded-full',
                                        { 'before:left-0': !collapsed, 'before:left-1': collapsed }
                                    )}
                                    onClick={onActivate}
                                    title={collapsed ? name : undefined}
                                >
                                    <Icon
                                        className={classNames({
                                            'size-5': !collapsed,
                                            'size-6': collapsed,
                                        })}
                                    />
                                    {!collapsed && name}
                                </Link>
                            )
                        }
                    })}
                </div>
            </div>
            <Divider />
        </>
    )
})
